import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDPMF1kbWsjpyd9gi5Tj4TaDDYao8MtqfM",
  authDomain: "modit-project.firebaseapp.com",
  projectId: "modit-project",
  storageBucket: "modit-project.firebasestorage.app",
  messagingSenderId: "519052140231",
  appId: "1:519052140231:web:c7a598284f5546568768e2"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'europe-central2');

export default app;